module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dealsThisWeek":"Deals this week","dealsToday":"dealsToday"},"fr":{"dealsThisWeek":"Dossiers cette semaine","dealsToday":"Dossiers aujourd\u0027hui"}}')
  delete Component.options._Ctor
}
